export const isValidIndex = <TItem>(index: number | null | undefined, array: TItem[]) => {
    return index !== undefined && index !== null && index >= 0 && index < array.length;
}

export const isEmpty = <TItem>(array: TItem[] | null | undefined) => {
    return array === undefined || array === null || array.length === 0;
}